module.exports = __webpack_public_path__ + "static/img/blocks.f74048e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/blocks.gif
// module id = 9FQ0
// module chunks = 1